var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"editor",attrs:{"options":_vm.options,"value":_vm.value},on:{"input":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }